import { getImageThumbnailUrl, Image } from '@/modules/store/models/Image';
import { PhotoIcon } from '@heroicons/react/24/outline';

const ImageThumbnail = (sku: { image: Image | Image[] }) => {
  const images = Array.isArray(sku.image) ? sku.image : [sku.image];

  return (
    <div className="w-24 h-24 p-1 flex items-center justify-center">
      {images?.[0]?.url ? (
        <img
          src={getImageThumbnailUrl(images[0])}
          alt="Product"
          className="max-w-full max-h-full object-contain"
        />
      ) : (
        <div className="flex flex-col items-center justify-center text-gray-400 bg-gray-50 border rounded-md w-20 h-20">
          <PhotoIcon className="w-8 h-8" aria-hidden="true" />
        </div>
      )}
    </div>
  );
};

export default ImageThumbnail;
